var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M23.9 21.78l-3.54-3.54a1.49 1.49 0 0 0-1.06-.44 1.53 1.53 0 0 0-1.06.44A5.94 5.94 0 0 0 20 14a6 6 0 1 0-6 6 5.94 5.94 0 0 0 4.24-1.76 1.51 1.51 0 0 0 0 2.12l3.54 3.54c.28.282.662.44 1.06.44a1.51 1.51 0 0 0 1.503-1.5c0-.398-.16-.78-.443-1.06zM14 19a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm9.19 4.19a.49.49 0 0 1-.35.15.47.47 0 0 1-.35-.15L19 19.66a.502.502 0 1 1 .71-.71l3.53 3.54a.47.47 0 0 1 .15.35.49.49 0 0 1-.2.35z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.9eaddd5d8b75d9ac2cc655491fe18bfb.svg";
export { ForwardRef as ReactComponent };